<div
  class="animate-in fade-in slide-in-from-bottom-2 flex flex-col gap-4 rounded-[12px] border border-gray-100 bg-white p-5 shadow-xl duration-500">
  <div class="flex flex-col gap-1.5 border-b-2 border-gray-300 pb-3">
    <h2 class="title text-[18px] font-bold" i18n="@@product.attributes.title">Product Attributes</h2>
  </div>
  @if (error()) {
    <div class="mb-4 rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">
      {{ error() }}
    </div>
  }

  <app-attribute-form
    [existingKeys]="existingTitleEnList()"
    [editData]="editAttrFormData()"
    (onAdd)="addAttributeKey($event)"
    (onEdit)="saveEditedAttr($event)"
    (onCancelEdit)="editAttrIndex.set(null)"
    (onImportClick)="showImportModal.set(true)" />

  <div class="relative mt-6">
    @if (attributesLoading()) {
      <div class="absolute inset-0 z-10 flex items-center justify-center bg-white/50 backdrop-blur-sm">
        <div class="borderPrimaryColor h-8 w-8 animate-spin rounded-full border-4 border-t-transparent"></div>
      </div>
    }
    <app-attributes-table
      [attributes]="attributesList()"
      (onDrop)="handleReorder($event)"
      (onAddValue)="openValueModal($event)"
      (onEditValue)="editAttributeValue($event.attrIdx, $event.valIdx)"
      (onDeleteValue)="requestDeleteValue($event.attrIdx, $event.valIdx)"
      (onRemove)="requestDeleteAttr($event)"
      (onEditAttr)="editAttrIndex.set($event)" />
  </div>

  <div class="mt-8 flex justify-end border-t border-gray-100 pt-8">
    <button
      (click)="saveNewChanges()"
      [disabled]="loading() || !canSaveNewChanges()"
      class="flex cursor-pointer items-center rounded-xl bg-gray-800 px-10 py-3 font-bold text-white shadow-lg transition-all hover:bg-gray-900 disabled:opacity-50"
      i18n="@@attr.button.saveEdit">
      @if (loading()) {
        <svg class="me-2 h-4 w-4 animate-spin" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
      }
      Save Changes
    </button>
  </div>

  <app-add-new-value
    #valueModal
    [hidden]="!showValueModal()"
    [existingValues]="currentAttrValues()"
    [editData]="editData()"
    (onSave)="handleSaveValue($event)"
    (onClose)="closeModal()" />
</div>

@if (showImportModal()) {
  <app-import-global-modal
    [globalAttributes]="globalAttributes()"
    [existingKeys]="existingTitleEnList()"
    (onClose)="showImportModal.set(false)"
    (onConfirm)="confirmImport($event)" />
}

@if (deleteConfig()) {
  <app-confirm-delete-modal
    [itemName]="deleteConfig()!.name"
    (onConfirm)="confirmDelete()"
    (onCancel)="deleteConfig.set(null)" />
}
